var runtime = require('./');

module.exports = wrap;
function wrap(template, templateName) {
  templateName = templateName || 'template';
  return Function('pug',
    template + '\n' +
    'return ' + templateName + ';'
  )(runtime);
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/pug-runtime/wrap.js
 ** module id = 189
 ** module chunks = 0
 **/